/**
 * Assigned `RegistrationStatus.statusID` values.
 *
 * These are *assigned* IDs, not auto-increment, and they are the ones the Enrolment sub-pages
 * already pin themselves to (`PendingEnrolments` = 0, `ActiveEnrolments` = 1,
 * `CancelledEnrolments` = -1). Anything beyond these three is site-configurable, which is why
 * `RegistrationsListView` still picks its KPI statuses by name.
 */
export const REGISTRATION_STATUS = {
  Pending: 0,
  Active: 1,
  Cancelled: -1,
} as const;
